import './temp-old';
import './core/core--events';
import getBodySettings from './site/global/page-settings';
import _bundle from './core/core--bundles';
import kendoComponents from './site/kendo-calls';
import siteGlobal, { primitiveHelpers, sendAfToken } from './site/global/all';
import uiGlobal from './site/ui/global/all';
import uiSectors from './site/ui/sectors/sectors';
import moduleCalls from './site/module-calls';

//Areas
import account from './site/account/all';
import dashboards from './site/dashboards/all';
import commissions from './site/commissions/all';
import compliance from './site/compliance/all';
import sales from './site/sales/all';
import operations from './site/operations/all';
import projectReview from './site/project-review/all';
import finance from './site/finance/all';
import cash from './site/cash/all';
import attachments from './site/attachments/all';
import reporting from './site/reporting/all';
import integrations from './site/integrations/all';

import apis from './api/all';
import scorecardWidgets from './site/dashboards/scorecard/scorecard-finance-widget';
import forms from './site/forms/all';
import test from './core/test/calls';
import { addResourceEntryWidget } from './site/ui/widgets/all';
import technology from './site/technology/technology';
import emailHubEditor from './site/email-hub/editor/email-hub-editor';

const { nameArea, nameController, nameAction, namePage } = getBodySettings('page');

scorecardWidgets($);

function limbach() {
    console.debug(`Area: ${nameArea}\nController: ${nameController}\nAction: ${nameAction}\nPage: ${namePage}`);
    primitiveHelpers();
    window.sendAfToken = sendAfToken;
    siteGlobal();
    kendoComponents();
    moduleCalls();
    uiGlobal();
    uiSectors();
    addResourceEntryWidget();

    account(nameController, nameAction, namePage);
    if(nameArea === 'commissions'){
        commissions(nameController, nameAction, namePage)
    }
    if (nameController === 'projectreview') projectReview(nameController, nameAction, namePage);
    if (nameController === 'mprexecutivesummary') projectReview(nameController, nameAction, namePage);
    if (nameController === 'finance') cash();
    if (nameArea === 'sales') sales(nameController, nameAction, namePage);
    if (nameArea === 'operations') operations(nameController, nameAction, namePage);
    if (nameArea === 'finance') finance(nameController, nameAction, namePage);
    forms();
    if (nameArea === 'compliance') compliance();
    if (nameArea === 'account') dashboards(nameController, nameAction, namePage);
    if (nameArea === 'integrations') integrations(nameController, nameAction, namePage);
    if (nameArea === 'technology') technology(nameController, nameAction, namePage);
    if (nameController === 'emailhub' && nameAction === 'editor') emailHubEditor();
    reporting();
    apis();
    attachments();
    test();
    _bundle.init();
}

$(limbach);
